import React from 'react';
import { motion } from 'framer-motion';

interface AboutExtrasSectionProps {
  pecaImage: string;
}

const AboutExtrasSection: React.FC<AboutExtrasSectionProps> = ({
  pecaImage,
}) => {
  return (
    <motion.section 
      id="sobre-extras" 
      className="py-12 sm:py-16 md:py-20 bg-gray-50"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          <div className="order-1">
            <span className="inline-flex rounded-full bg-white border border-[#d7deeb] px-4 py-2 text-xs tracking-[0.16em] uppercase text-[#2a3c5c] font-medium mb-4 block w-fit">
              Extensão universitária
            </span>
            <h2 className="text-2xl sm:text-3xl font-semibold mb-4 sm:mb-6 text-[#2a3c5c]">PECA — Faculdade de Ciências Médicas da Santa Casa de SP</h2>
            <p className="text-gray-600">
              Desde 2024 participo com a equipe de psicologia, através do PROSA (Programa Sou Acolhimento), no Programa Expedições Científicas e Assistenciais (PECA). Essa iniciativa de extensão da Faculdade de Ciências Médicas da Santa Casa de São Paulo (FCMSCSP) reúne estudantes e profissionais de saúde, que dedicam uma semana das férias de janeiro para oferecer atendimento multidisciplinar a comunidades em diferentes contextos socioeconômicos. A experiência fortalece o aprendizado prático, estimula a responsabilidade social e valoriza o cuidado integral ao paciente. Ao final de cada expedição, todos retornam enriquecidos por novas vivências e com a sensação de dever cumprido.
            </p>
          </div>
          <div className="order-2 mt-6 md:mt-0 flex justify-center">
            <div className="w-full max-w-md md:max-w-full overflow-hidden rounded-2xl border border-[#d7deeb] bg-white shadow-[0_20px_55px_rgba(27,45,78,0.16)]">
              <img
                src={pecaImage}
                alt="Participação no PECA - Santa Casa"
                className="w-full h-auto object-cover object-center"
                width="600"
                height="400"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutExtrasSection;

